/** Shared with World Cup tab bar and other underline tab rows */
export const UNDERLINE_TAB_ANIMATION_MS = 220

export const UNDERLINE_TAB_ICON_SIZE_DEFAULT = 17
